import {pickAll, pipe} from 'ramda'
import renamePropName from 'utils/renamePropName'

const searchWebsiteParams = pipe(
  pickAll(['checkIn', 'checkOut', 'currency', 'hotelId', 'locale', 'rooms']),
  renamePropName('currency', 'curr'),
  renamePropName('locale', 'lang')
)

export default searchWebsiteParams
